import React, { useEffect, MouseEventHandler, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { makeReference, useMutation } from '@apollo/client';

import { Prescription } from '@interfaces';
import { ModalImage } from '@components/ModalImage';
import {
  removePrescription,
  RemovePrescriptionMutationParams,
  RemovePrescriptionMutationResponse,
} from '@queries/prescription/mutations/removePrescription';

import {
  UploadImageScrollImagesDiv,
  UploadImageScrollImages,
  DeleteIconButton,
  CloseIconSized,
  UploadImageImagesDivLoading,
} from '../styles/UploadImageItem.styles';

const defaultImage = '/assets/images/prescription-default-image.png';
const defaultPdfImage = '/assets/images/prescription-default-pdf-image.png';
interface UploadImageItemProps {
  loading?: {};
  prescription?: Prescription;
  allowRemove?: boolean;
}

export function UploadImageItem(props: UploadImageItemProps) {
  const { loading, allowRemove = true } = props;
  const prescription = props.prescription || { url: '', uuid: '' };
  const [imageModal, setImageModal] = useState(false);
  const [imageUrl, setImageUrl] = useState(prescription?.url);

  const [removePrescriptionMutation] = useMutation<
    RemovePrescriptionMutationResponse,
    RemovePrescriptionMutationParams
  >(removePrescription('removePrescription'), {
    variables: { params: { uuid: prescription.uuid } },
    update(cache, { data }) {
      cache.modify({
        id: cache.identify(makeReference('ROOT_QUERY')),
        fields: {
          pendingPrescriptions(prescriptions: Prescription[], { readField }) {
            return prescriptions.filter(
              (prescription) =>
                readField('id', prescription) !== data.removePrescription.id,
            );
          },
        },
      });
    },
  });

  const handleRemove: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    void removePrescriptionMutation();
  };

  useEffect(() => {
    setImageUrl(prescription.url);
  }, [prescription.url]);

  const handleImageError = () => {
    setImageUrl(defaultImage);
  };

  return (
    <>
      {loading ? (
        <UploadImageImagesDivLoading>
          <CircularProgress size={30} color="primary" />
        </UploadImageImagesDivLoading>
      ) : (
        <>
          <UploadImageScrollImagesDiv
            onClick={
              imageUrl !== defaultImage ? () => setImageModal(true) : undefined
            }
          >
            {prescription.url.includes('.pdf') ? (
              <UploadImageScrollImages
                data={defaultPdfImage}
                type="image/png"
                title="Contenedor"
              ></UploadImageScrollImages>
            ) : (
              <UploadImageScrollImages
                data={imageUrl}
                type="image/png"
                title="Contenedor"
              ></UploadImageScrollImages>
            )}
            {allowRemove && (
              <DeleteIconButton
                onClick={prescription.url ? handleRemove : null}
              >
                <CloseIconSized />
              </DeleteIconButton>
            )}
          </UploadImageScrollImagesDiv>
          {/* Receta */}
          <ModalImage
            imageModal={imageModal}
            setImageModal={setImageModal}
            imageUrl={imageUrl}
            handleImageError={handleImageError}
            productName={'Receta'}
            isProduct={false}
          />
        </>
      )}
    </>
  );
}
